<template>
  <div>
    <div @click="launchFile()">
      <slot name="activator"></slot>
    </div>

    <input type="file"
       ref="file"
       :name="filename"
       accept=".xls, .xlsx"
       v-on:change="changeFile($event.target.files)"
       style="display:none">
       
    <v-dialog 
      v-model="dialog"
      width="500">
      <v-card
        class="pa-0 ma-0"
        flat>
        <v-card
          color="red accent-2">
          <v-list-item>
            <v-list-item-avatar color="red accent-2" size="30">
              <v-icon color="white" large>mdi-alert</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-card-text class="caption white--text pa-0">
                {{ message.error }}
              </v-card-text>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { TokenService } from "../service/Storage.Service";
  export default {
    name: 'file-input',
    data: () => ({
      dialog: false,
      filename: 'file',
      process: {
        load: false
      },
      message: {
        error: ''
      }
    }),
    methods: {
      launchFile () {
        this.$refs.file.click()
      },
      async changeFile (file) {
        let docs = file[0]
        if (file.length > 0) {
          if (docs.type !== 'application/vnd.ms-excel' && docs.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            this.dialog = true
            this.message.error = 'Silahkan pilih file excel dengan format .xls / .xlsx'
          } else {
            let formData = new FormData()
            formData.append('file', docs)

            this.process.load = true

            this.$emit('input', {
              process : this.process.load
            })

            fetch(`${process.env.VUE_APP_API_URL}admin/candidates/upload_file`, {
              method: 'POST',
              body: formData,
              headers: {
                Authorization: `${process.env.VUE_APP_XAUTH}`,
                token: TokenService.getToken()
              } 
            })
            .then(res => res.json())
            .then(response => {
              if (response.status === 200) {
                this.process.load = false

                this.$emit('input', {
                  data: response.results.data,
                  name: docs.name,
                  process : this.process.load
                })
              } else {
                this.process.load = false

                this.$emit('input', {
                  process : this.process.load
                })

                this.dialog = true
                this.message.error  = response.message
              }
            })
          }
        }
      }
    }
  } 
</script>